import { useEffect } from 'react';
export const useSubscribe = (listener, deps = []) => {
    useEffect(() => {
        const subscription = listener();
        return () => subscription.unsubscribe();
    }, deps);
};
